import { environment } from "src/environments/environment";

export const appConstants = {
  FAVICON_URL: environment.legacyAppUrl + '/favicon/favicon',
  LOGO_URL: environment.legacyAppUrl + '/logos/logo',
  WEBSITE_URL: 'https://www.brandshelter.com',
};
